import { render, staticRenderFns } from "./Judging.vue?vue&type=template&id=f7924926&scoped=true"
import script from "./Judging.vue?vue&type=script&lang=js"
export * from "./Judging.vue?vue&type=script&lang=js"
import style0 from "./Judging.vue?vue&type=style&index=0&id=f7924926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7924926",
  null
  
)

export default component.exports